import forecastQueryKeys from './forecastQueryKeys'
import { fetchForecasts } from '../../service/forecastService'
import { BudgetingScenario } from '../../types/BudgetingScenario'
import { sortById } from '../../../../utils/helpers'
import { normalizeScenario } from '../../utils/scenarioUtils'

export const getForecastOptions = <TData = BudgetingScenario[]>(
  companyId: string,
  select?: (data: BudgetingScenario[]) => TData
) => {
  return {
    queryKey: forecastQueryKeys.list(companyId),
    queryFn: fetchForecasts,
    gcTime: 15 * 60 * 1000,
    enabled: !!companyId,
    select: (data: BudgetingScenario[]) => {
      const sortedData = sortById(data)
      const normalizedData = sortedData.map(normalizeScenario)
      return select ? select(normalizedData) : (normalizedData as TData)
    }
  }
}
